import { render } from "./mobile_fields.vue?vue&type=template&id=5fdf72f3"
import script from "./mobile_fields.vue?vue&type=script&lang=js"
export * from "./mobile_fields.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__